import { Component, Input, OnInit, AfterViewInit, ChangeDetectorRef, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { QueryBuilderClassNames, QueryBuilderConfig } from 'ngx-angular-query-builder';
import { NgxSpinnerService } from 'ngx-spinner';
import { TargetedGroupModel } from '../../../../business-entities/targeted-group-model';
import { CampaignMemberResponse } from '../../../../business-entities/campaign-member-model';
import { TargetedGroupService } from '../../../../business-services/targeted-group.service';
import { ToastrService } from 'ngx-toastr';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { TranslateService } from '@ngx-translate/core';
import { BrandService } from '../../../../business-services/brand.service';
import { TargetGroupRequestModel } from '../../../../business-entities/campaign-modal';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-edit-targeted-group',
  templateUrl: './edit-targeted-group.component.html',
  styleUrls: ['./edit-targeted-group.component.css'],
})
export class EditTargetedGroupComponent implements OnInit, AfterViewInit {
  //#region  variable declaration
  isForView: boolean = false;
  showCustomer = false;
  paginationSub: Subscription;
  total$: Observable<number>;
  targetedGroupRequest: TargetGroupRequestModel = {
    numberOfRecord: 25,
    searchTerm: '',
    sortColumn: '',
    sortDirection: '',
    startRecordNumber: 0,
    IncludeQuery: '',
    ExcludeQuery: ''
  }
  name: string = '';
  description: string = '';
  JsonQuery = '';
  campaignMembers: CampaignMemberResponse[] = [];
  targetedGroup: TargetedGroupModel = { name: '', description: '', sqlQuery: '', jsonQuery: '' };
  targetedGroupform: FormGroup;
  scrollDistance = 1;
  throttle = 100;
  targetedCustomer: any;
  totalCount: any;
  classNames: QueryBuilderClassNames = {
    removeIcon: 'fa fa-minus',
    addIcon: 'fa fa-plus',
    arrowIcon: 'fa fa-chevron-right px-2',
    rightAlign: 'order-12 ml-auto',
    switchRow: 'd-flex px-2',
    switchGroup: 'd-flex align-items-center',
    row: 'row p-2 m-1',
    rule: 'border',
    ruleSet: 'border',
    invalidRuleSet: 'alert alert-danger',
    emptyWarning: 'text-danger mx-auto',
    operatorControl: 'form-control',
    operatorControlSize: 'col-auto pr-0',
    fieldControl: 'form-control',
    fieldControlSize: 'col-auto pr-0',
    entityControl: 'form-control',
    entityControlSize: 'col-auto pr-0',
    inputControl: 'form-control',
    inputControlSize: 'col-auto'
  }
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  public queryCtrl: FormControl;
  public isDisabled: boolean = false;
  public DisabledText = 'Disable';
  public brandList = []

  query = { condition: 'and', rules: [] };
  config: QueryBuilderConfig = {
    fields: {
      Year: { name: 'Model Year', type: 'number' },
      CITY: { name: 'City', type: 'string', operators: ['=', '!=', 'like'] },
      CompanyMakeCode: { name: 'Brand', type: 'category', options: this.brandList },
      DIAL_CODE: { name: 'Dial Code', type: 'number' }
    }
  }
  @Input() modelFlag: any;
  @Input() tgmodel: any;
  validQuery: boolean = true;
  invalidName: boolean = false;
  requiredQuery: boolean = false;
  //#endregion

  //#region constructor declaration
  constructor(
    private activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private userService: UserDataService,
    private translate: TranslateService,
    private brandService: BrandService,
    private cd: ChangeDetectorRef,
    private excelService: ExcelService,
    private targetedGroupService: TargetedGroupService
  ) { }
  //#endregion

  //#region ngOnInit
  ngOnInit(): void {
    this.targetedGroupform = this.formBuilder.group({
      name: ['', [Validators.required]],
      description: ['']
    });
    this.getBrand();
    if (this.modelFlag !== 'add') {
      const targetedGroupvalue = this.tgmodel;
      this.targetedGroupform.patchValue({
        name: targetedGroupvalue.name,
        description: targetedGroupvalue.description,
      });
      this.query = JSON.parse(this.tgmodel.jsonQuery)
    }
    this.queryCtrl = this.formBuilder.control(this.query);
    if (this.modelFlag === 'view') {
      this.targetedGroupform.controls['name'].disable();
      this.targetedGroupform.controls['description'].disable();
      this.isForView = true;
    }
  }
  //#endregion

  //#region API methods
  getBrand() {
    this.brandService.getBrand().then(response => {
      if (response) {
        response.forEach(x => {
          this.brandList.push({ name: x.brandName, value: x.brandCode })
        });
      }
    });
  }

  saveandNext() {
    this.isvalid('S');
    if (!this.invalidName && !this.requiredQuery && this.validQuery) {
      this.targetedGroup.name = this.cf.name.value;
      this.targetedGroup.description = this.cf.description.value;
      this.targetedGroup.sqlQuery = this.basicRulesetToSQL(this.query);
      this.targetedGroup.jsonQuery = JSON.stringify(this.query);
      this.targetedGroup.updatedBy = this.userService.currentUserValue.name;
      this.targetedGroup.id = this.tgmodel.id;
      let successmsg = this.translate.instant("lblTargetdGroupUpdated");
      if (this.modelFlag === 'add') {
        this.targetedGroup.createdBy = this.userService.currentUserValue.name;
        successmsg = this.translate.instant("lblTargetdGroupCreated");
      }
      this.spinner.show();
      this.targetedGroupService.addtargetedGroup(this.targetedGroup).then((response: any) => {
        if (response && response.statusCode == 201) {
          this.toastr.success(successmsg);
          this.activeModal.close({ success: true });
        }
      }).finally(() => {
        this.spinner.hide();
      });
    }
  }

  getCampaignMembers(isReset: boolean = true) {
    this.showCustomer = true;
    this.targetedGroupRequest.IncludeQuery = this.basicRulesetToSQL(this.query);
    if (isReset) {
      this.targetedGroupRequest.startRecordNumber = 0;
    }
    this.spinner.show();
    this.isvalid('');
    if (!this.requiredQuery && this.validQuery) {
      this.targetedGroupService.getCampaignMemberByQuery(this.targetedGroupRequest).then((response: any) => {
        if (isReset) {
          this.campaignMembers = [];
          this.totalCount = 0;
        }
        if (response?.data.length > 0) {
          this.campaignMembers.push(...response.data);
          this.totalCount = response.data[0].totalCount;
        }
      }).finally(() => {
        this.spinner.hide();
      });;
    }
    else {
      this.showCustomer = false;
    }
    this.spinner.hide();
  }
  //#endregion

  //#region other methods
  ngAfterViewInit(): void {
    if (this.modelFlag === 'view') {
      this.queryCtrl.disable()
      this.cd.detectChanges();
    }
  }

  get cf() {
    return this.targetedGroupform.controls;
  }

  OnClose() {
    this.activeModal.close()
  }

  clear() {
    this.showCustomer = false;
    this.campaignMembers = [];
  }

  isvalid(key: string) {
    if (key == 'S') {
      this.invalidName = false;
      if (!this.cf.name.value)
        this.invalidName = true;
    }
    this.requiredQuery = false;
    if (this.query.rules.length == 0)
      this.requiredQuery = true;
    else
      this.basicRulesetToSQL(this.query)
  }

  valueToSQL(value) {
    switch (typeof value) {
      case 'string':
        return "'" + value + "'";
      case 'boolean':
        return value ? '1' : '0';
      case 'number':
        if (isFinite(value)) return value;
    }
  }

  isDefined(value) {
    return value !== undefined;
  }

  basicRulesetToSQL(ruleset) {
    this.validQuery = true;
    return ruleset.rules.map((rule) => {
      if (rule.rules) {
        return "(" + this.basicRulesetToSQL(rule) + ")";
      }
      let column = rule.field,
        operator, value;

      switch (rule.operator) {
        case "is null":
        case "is not null":
          operator = rule.operator;
          value = "";
          break;
        case "in":
        case "not in":
          operator = rule.operator;
          if (this.isDefined(rule.value[0]) && Array.isArray(rule.value) && rule.value.length)
            value = "(" + rule.value.map(this.valueToSQL).filter(this.isDefined).join(", ") + ")";
          break;
        case "like":
          operator = rule.operator;
          value = this.valueToSQL(rule.value);
          if (this.isDefined(rule.value))
            value = this.valueToSQL("%" + rule.value + "%");
          break;
        default:
          operator = rule.operator;
          value = this.valueToSQL(rule.value);
          break;
      }

      if (this.isDefined(column) && this.isDefined(value) && this.isDefined(operator)) {
        return "(" + (column + " " + operator + " " + value).trim() + ")";
      } else {
        this.validQuery = false;
      }
    }).filter(this.isDefined).join(" " + ruleset.condition + " ");
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.campaignMembers.length) {
      this.targetedGroupRequest.startRecordNumber = this.campaignMembers.length;
      this.getCampaignMembers(false);
    }
  }
  onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.targetedGroupRequest.sortColumn = column;
    this.targetedGroupRequest.sortDirection = direction;
    this.targetedGroupRequest.startRecordNumber = 0;
    this.spinner.show();
    this.getCampaignMembers();
  }

  public async exportAsXLSX(_excel: number) {
    this.spinner.show();
    this.targetedCustomer = this.targetedcustomerExcelDataMapper(this.campaignMembers);
    this.spinner.hide();
    this.excelService.exportAsExcelFile(this.targetedCustomer, 'TagetedCustomer_af');
  }

  private targetedcustomerExcelDataMapper(List: any) {
    let supperArray = [];
    if (List && List.length > 0) {
      for (let index = 0; index < List.length; index++) {
        const element = List[index];
        let single = Object();
        single.No = index + 1;
        single.Name = element.name;
        single.Email = element.email;
        single.MobileNo = element.mobile;
        single.City = element.city;
        single.EmailConsent = element.emailConsent;
        single.SMSConsent = element.smsConsent;
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  public get documentTypes(): typeof Enums.DocumentsType {
    return Enums.DocumentsType;
  }
  //#endregion

}
